import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const ResearchItemSkeleton: FC<{
  hasAuthor?: boolean;
  hasLike?: boolean;
  hasViewCount?: boolean;
}> = ({ hasAuthor, hasViewCount, hasLike }) => (
  <div className="d-flex h-100">
    <div className="pe-3 flex-shrink-0 flex-grow-0">
      <em className="icon icon-md">
        <Skeleton width="1em" />
      </em>
    </div>
    <div className="flex-grow-1 flex-shrink-1 d-flex flex-column">
      <div className="flex-grow-1 pt-1">
        <span className="text-primary mt-1">
          <h5>
            <Skeleton count={2} />
          </h5>
        </span>
      </div>
      <div className="text-secondary d-flex justify-content-between align-items-end">
        <div>
          {hasAuthor && (
            <>
              <u>
                <Skeleton width="8em" />
              </u>
              <span className="px-1">
                <Skeleton width="1em" />
              </span>
            </>
          )}
          <span>
            <Skeleton width="10em" />
          </span>
        </div>
        <div className="align-self-end">
          {hasViewCount && (
            <span className="mx-1">
              <i className="icon icon-sm me-1">
                <Skeleton width="1em" />
              </i>
              <Skeleton width="2em" />
            </span>
          )}
          {hasLike && (
            <span className="mx-1">
              <i className="icon icon-sm me-1">
                <Skeleton width="1em" />
              </i>
              <Skeleton width="2em" />
            </span>
          )}
        </div>
      </div>
    </div>
  </div>
);

ResearchItemSkeleton.displayName = 'ResearchItemSkeleton';
